export const genderTypes = Object.freeze({
  0: "Not Known",
  1: "Male",
  2: "Female",
  9: "Not Specified",
});
